"use client"

import { useActionState } from "react"
import { declarerRetractation, rechercherCommande } from "@/app/actions/suivi"
import { dateLongue } from "@/lib/format"
import { FormError, SubmitButton } from "./form"
import { RetractionForm } from "./Retraction"

export function WithdrawalLookup() {
  const [state, action] = useActionState(rechercherCommande, undefined)
  if (state?.ok && state.data) {
    const { order, email, numero } = state.data
    return (
      <div className="grid gap-4">
        <p>
          Commande <strong>{order.number}</strong> du {dateLongue(order.created_at)}
          {order.retraction.deadline && <> — délai de rétractation jusqu’au {dateLongue(order.retraction.deadline)}</>}.
        </p>
        <RetractionForm
          items={order.items}
          action={declarerRetractation}
          hidden={{ email, numero }}
          defaultName={order.customer_name}
          defaultEmail={email}
        />
      </div>
    )
  }
  return (
    <form action={action} className="grid gap-4">
      <div>
        <label htmlFor="w-email" className="etiquette">
          E-mail utilisé pour la commande
        </label>
        <input id="w-email" name="email" type="email" required className="champ" autoComplete="email" />
      </div>
      <div>
        <label htmlFor="w-num" className="etiquette">
          Numéro de commande
        </label>
        <input id="w-num" name="numero" required inputMode="numeric" className="champ" placeholder="ex. 12" />
        <p className="aide">Il figure dans l’e-mail de confirmation (« commande n° … »).</p>
      </div>
      <FormError state={state} />
      <SubmitButton className="bouton w-full sm:w-auto" pending="Recherche…">
        Retrouver ma commande
      </SubmitButton>
    </form>
  )
}
